export const BucketPage = () => {
  return (
    <>
      <div>Explore documents in S3 bucket Full Frontal Cloud</div>
    </>
  );
};
